import { navigate } from "../lib/router.ts";
import { SearchBar } from "./SearchBar.tsx";
import logoSrc from "../logo.png";

export function Header() {
  return (
    <header className="border-b border-border sticky top-0 z-50 bg-surface/90 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-6">
        <a
          href="/"
          className="flex items-center gap-2 text-sm font-medium text-text-primary hover:text-accent transition-colors shrink-0 tracking-tight"
          onClick={(e) => { e.preventDefault(); navigate("/"); }}
        >
          <img src={logoSrc} alt="Logo" className="w-5 h-5 invert brightness-0" />
          There's an OS for That
        </a>

        <nav className="hidden sm:flex items-center gap-6 text-xs text-text-secondary">
          <a
            href="/"
            onClick={(e) => { e.preventDefault(); navigate("/"); }}
            className="hover:text-text-primary transition-colors uppercase tracking-widest"
          >
            Browse
          </a>
        </nav>

        <SearchBar />
      </div>
    </header>
  );
}
